import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";

export const LoadPanel = ({ load, wipLimit }) => (
  <Card data-testid="load-panel">
    <CardHeader className="pb-3">
      <CardTitle className="text-base">Load</CardTitle>
      <p className="text-xs text-muted-foreground">
        Who's buried and who's idle. Limit is {wipLimit} per person.
      </p>
    </CardHeader>
    <CardContent>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Staff</TableHead>
            <TableHead className="text-right">Holding</TableHead>
            <TableHead className="text-right">Oldest claim</TableHead>
            <TableHead className="text-right">Done this week</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {load.map((row) => {
            const full = row.claimed_count >= wipLimit;
            const idle = row.claimed_count === 0;
            const oldest = row.oldest_claim_hours;
            return (
              <TableRow key={row.user_id} data-testid={`load-row-${row.user_id}`}>
                <TableCell className="font-medium">{row.name}</TableCell>
                <TableCell
                  className={`text-right tabular-nums font-semibold ${
                    full ? "text-rose-600" : idle ? "text-muted-foreground" : "text-foreground"
                  }`}
                >
                  {row.claimed_count}
                  {full && " · full"}
                  {idle && " · idle"}
                </TableCell>
                <TableCell
                  className={`text-right tabular-nums ${
                    oldest >= 72 ? "text-rose-600" : oldest >= 48 ? "text-amber-600" : "text-muted-foreground"
                  }`}
                >
                  {oldest ? `${Math.round(oldest)}h` : "—"}
                </TableCell>
                <TableCell className="text-right tabular-nums">{row.completions_this_week}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);
